<template>

    <div id="tag_bar" class="w-full py-4 px-4 h-12 border-t border-b border-theme-discrete text-theme-discrete flex flex-row items-center overflow-x-scroll">

        <span class="text-base text-theme-discrete font-bold mr-4">{{ translate('trending') }}: </span>

        <span>
            <span
                class="mr-2 px-4 py-2 bg-theme-level3 hover:bg-theme-level4 border rounded-full border-theme-muted hover:border-theme-main text-sm text-theme-discrete hover:text-theme-main cursor-pointer"
                @click="goHome">
                {{ language==='es' ? 'Todas' : 'All' }}
            </span>
        </span>

        <span v-for="tag in tagsCollection">
            <span
                class="mr-2 px-4 py-2 bg-theme-level3 hover:bg-theme-level4 border rounded-full border-theme-muted hover:border-theme-main text-sm text-theme-discrete hover:text-theme-main cursor-pointer whitespace-no-wrap"
                @click="showTagContent(tag.id)">{{ language==='es' ? tag.name : tag.name_en}}</span>
        </span>

    </div>

</template>

<script>

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        props: ['language'],

        data() {

            return {

                tagsCollection: null

            }

        },

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            showTagContent(tagId) {

                window.location = '/' + this.language + '/element/tag/' + tagId;

            },

            goHome() {
                window.location = '/'
            }

        },

        created() {

            axios.get('/api/getPopularTags/' + this.language)
                .then((response) => {
                    this.tagsCollection = response.data
                })
                .catch((error) => {
                    console.log('Error fetching POPULAR TAGS: ' + error);
                })

        }

    }

</script>
